import { LOCALE_ID, NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TokenInterceptor } from './guards/interceptor/token.interceptor';
import { PrimeModule } from './shared/primeng/primeng-module';
import myLocaleIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { SharedModule } from './shared/shared-module.module';
import { environment } from '../environments/environment';
import { ApiModule } from './api/api.module';
import { WalletTransfersComponent } from './socialtravels-cms/wallet-transfers/wallet-transfers.component';
registerLocaleData(myLocaleIt);

@NgModule({
  declarations: [AppComponent, LoginComponent, WalletTransfersComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PrimeModule,
    SharedModule,
    JwtModule.forRoot({
      config: {
        disallowedRoutes: [''],
      },
    }),
    ApiModule.forRoot({
      rootUrl: environment.baseUrl,
    }),
  ],
  providers: [
    provideClientHydration(),
    ConfirmationService,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'it' },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
})
export class AppModule {}
